export default __webpack_public_path__ + "static/media/seaoil-logo.d551c7d6.svg";